import { render, staticRenderFns } from "./ForgotPasswordStepperDialog.vue?vue&type=template&id=fa5ddc74&scoped=true&"
import script from "./ForgotPasswordStepperDialog.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordStepperDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ddc74",
  null
  
)

export default component.exports